var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomertime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 15,
    fill: "#D2D8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9742 19.1665C30.7142 19.1665 19.1667 30.7398 19.1667 44.9998C19.1667 59.2598 30.7142 70.8332 44.9742 70.8332C59.2601 70.8332 70.8334 59.2598 70.8334 44.9998C70.8334 30.7398 59.2601 19.1665 44.9742 19.1665ZM45.0001 65.6665C33.5817 65.6665 24.3334 56.4182 24.3334 44.9998C24.3334 33.5815 33.5817 24.3332 45.0001 24.3332C56.4184 24.3332 65.6668 33.5815 65.6668 44.9998C65.6668 56.4182 56.4184 65.6665 45.0001 65.6665ZM44.4317 32.0832H44.2768C43.2434 32.0832 42.4167 32.9098 42.4167 33.9432V46.1365C42.4167 47.0407 42.8817 47.8932 43.6826 48.3582L54.4034 54.7907C55.2818 55.3073 56.4184 55.049 56.9351 54.1707C57.0648 53.9615 57.1511 53.7284 57.1888 53.4851C57.2265 53.2419 57.2149 52.9936 57.1547 52.7549C57.0944 52.5163 56.9867 52.2922 56.838 52.0961C56.6894 51.8999 56.5027 51.7357 56.2893 51.6132L46.2917 45.6715V33.9432C46.2917 32.9098 45.4651 32.0832 44.4317 32.0832V32.0832Z",
    fill: "#5E72E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomertime);
export default __webpack_public_path__ + "static/media/customertime.5c0ddc4dee4de3d9fa0dd1701154d9cf.svg";
export { ForwardRef as ReactComponent };